module.exports = __webpack_public_path__ + "img/logo.aca52316.png";